import { render, staticRenderFns } from "./TeleMarketUserManage.vue?vue&type=template&id=643bb4af&scoped=true"
import script from "./TeleMarketUserManage.vue?vue&type=script&lang=js"
export * from "./TeleMarketUserManage.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketUserManage.vue?vue&type=style&index=0&id=643bb4af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643bb4af",
  null
  
)

export default component.exports